/**
 * @ Author: Housefolios
 * @ Create Time: 2021-11-22 08:46:15
 * @ Modified by: David Helmick
 * @ Modified time: 2025-05-08 11:38:30
 * @ Description: Allows users to send an email for reseting their password
 */

import React, { Fragment, useState } from 'react'

import {
  Grid, Card, CardContent, IconButton, Typography, Backdrop, CircularProgress } from '@mui/material'
import {
  TextValidator,
  ValidatorForm} from '@/housefolios-components/shared/muiFormValidator'
import { VALIDATION_RULES } from '@/constants/validation'
import { FORGOT_PASSWORD } from '../queries'
import { enqueueSnackbar } from 'notistack'
import CloseIcon from '@mui/icons-material/Close'
import {
  AuthCardHeader,
  AuthMobileLogo,
  AuthNavLink,
  AuthPageShell,
  AuthPrimaryButton,
  authBackdropSx,
  authCardSx,
  authCardWrapSx,
  authFlexSpacerSx,
  authFormSx,
  authSnackbarCloseIconSx,
  authTextEndSx,
} from '../authChrome'
import housefoliosLogo from '@/assets/images/HousefoliosCloudTransparent.png'
import { get } from '@/utils/lodash'
import useAffiliate from '@/hooks/useAffiliate'
import { useMutation } from '@apollo/client/react'

const hostName = import.meta.env.VITE_HOSTNAME

function ForgotPasswordComponent(props) {
  const [login, setLogin] = useState('')

  function getCookie(cName) {
    const name = cName + '='
    const cDecoded = decodeURIComponent(document.cookie)
    const cArr = cDecoded.split('; ')
    let res
    cArr.forEach((val) => {
      if (val.indexOf(name) === 0) res = val.substring(name.length)
    })
    return res
  }

  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  let source = urlParams.get('source')
  let sourceCookie = getCookie('SourceSignUp')
  let headerImage = housefoliosLogo
  const [{ affiliate, affiliateLoading, urlHelmetData }] = useAffiliate({
    memberValue:
      sourceCookie === 'null' ? source : sourceCookie || source,
  })

  headerImage =
    get(affiliate, 'signIn.headerImage.0.url') ||
    urlHelmetData?.icon ||
    housefoliosLogo

  const [forgotPassword] = useMutation(FORGOT_PASSWORD)

  const onSubmit = (event, forgotPassword) => {
    forgotPassword({
      variables: { login }})
      .then(async ({ data  }) => {
        enqueueSnackbar(
          'Check your email for a reset password link',
          {
            variant: 'success',
            action: (key) => (
              <Fragment>
                <IconButton
                  onClick={() => {
                    props.closeSnackbar(key)
                  }}
                  size="large"
                >
                  <CloseIcon sx={authSnackbarCloseIconSx} />
                </IconButton>
              </Fragment>
            )},
        )
        window.location.href = '/signin'
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: 'error',
          action: (key) => (
            <Fragment>
              <IconButton
                onClick={() => {
                  props.closeSnackbar(key)
                }}
                size="large"
              >
                <CloseIcon sx={authSnackbarCloseIconSx} />
              </IconButton>
            </Fragment>
          )})
      })
    event.preventDefault()
  }

  if (affiliateLoading)
    return (
      <Backdrop open={true} sx={authBackdropSx}>
        <CircularProgress color="inherit" />
      </Backdrop>
    )

  return (
    <AuthPageShell>
        <AuthMobileLogo src={headerImage} />
        <Grid sx={authCardWrapSx}>
          <ValidatorForm
            sx={authFormSx}
            onSubmit={(event) => onSubmit(event, forgotPassword)}
          >
            <Card sx={authCardSx}>
              <CardContent>
                <Grid container direction="column" spacing={4}>
                  <Grid>
                    <AuthCardHeader
                      title="Recover password"
                      subtitle="Enter your email to reset your password"
                      logoSrc={headerImage}
                    />
                  </Grid>
                  <Grid>
                    <Grid container direction="row" spacing={2}>
                      <Grid size={12}>
                        <TextValidator
                          fullWidth
                          variant="outlined"
                          id="textfield-email"
                          label="Email Address"
                          onChange={(event) => setLogin(event.target.value)}
                          value={login}
                          validators={VALIDATION_RULES.email.validators}
                          errorMessages={
                            VALIDATION_RULES.email.errorMessages
                          }
                        />
                      </Grid>
                      <Grid size={12}>
                        <AuthPrimaryButton type="submit">
                          Send password
                        </AuthPrimaryButton>
                      </Grid>
                      <Grid size={12}>
                        <Grid
                          container
                          direction="row"
                          wrap="nowrap"
                          sx={{
                            alignItems: 'center',
                          }}
                        >
                          <Grid>
                            <AuthNavLink
                              href={
                                hostName === 'localhost' ||
                                hostName === 'dev-admin.housefolios.com'
                                  ? '/createAccount'
                                  : 'https://housefolios.com/pricing'
                              }
                            >
                              Create account
                            </AuthNavLink>
                          </Grid>
                          <Typography sx={authFlexSpacerSx} />
                          <Grid sx={authTextEndSx}>
                            <AuthNavLink href="/signin">Sign in</AuthNavLink>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </ValidatorForm>
        </Grid>
    </AuthPageShell>
  );
}

export default ForgotPasswordComponent
